import {FormattedNumber} from "react-intl";

export type NumberProps = {
    value: number;
    format?: string;
};

export function Number(props: NumberProps) {
    return <FormattedNumber value={props.value} />
}
